import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    dataInfo: {}, // 响应式数据
    activexitong: 0
  },
  getters: {
    activexitong(state) {
      return state.activexitong
    },
    activedataInfo(state) {
      return state.dataInfo
    }
  },
  mutations: {
    increment(state, info) {
      state.dataInfo = info;
    },
    incrementactivexitong(state, activexitong) {
      console.log(activexitong, "===========")
      state.activexitong = activexitong;
    }
  }
});


export default store



// WEBPACK FOOTER //
// ./src/store/index.js